/// <reference path="cambioEstadoFinal.html" />
'use strict';

angular.module('TurneroApp').component('coCambiarEstadosFinales', {
	bindings: {
		idAgenda: '<',
		turnos: '<',
		centroAtencionSeleccionado: '<',
		ctrlPadre: '='
	},
	controller: [
		 'turnosService',
		 'utilsService',
		 'TurneroAppConstant',
		 '$mdDialog',
         'agendaService',
         'usuariosService',
         function (turnosService, utilsService, TurneroAppConstant, $mdDialog, agendaService, usuariosService) {
		 	var ctrl = this;
		 	ctrl.CambioEstadoTurno = {};
		 	ctrl.error = {};
		 	ctrl.Estados = TurneroAppConstant.Estados.Turno;

		 	ctrl.limpiarVariables = function () {
		 		ctrl.error = {};
		 	};

		 	ctrl.$onChanges = function () {
                  if (ctrl.idAgenda && ctrl.turnos && ctrl.centroAtencionSeleccionado) {
                        usuariosService.Traer_Usuarios_Control_Permisos({ 'Id_Centro_Atencion': ctrl.centroAtencionSeleccionado.id, 'Id_Agenda': ctrl.idAgenda }).$promise.then(function (resultado) {
                            ctrl.Usuarios_Agenda = resultado.Data;
                            ctrl.CambioEstadoTurno = {};
                        }).catch(function (error) {
                            utilsService.errores(error);
                        });
		 		  }
		 	}


		 	ctrl.cambiarEstado = function (item) {

		 		ctrl.error.Id_Centro_Usuario = !item.Id_Centro_Usuario;
		 		ctrl.error.Estado = !item.Id_Estado;
		 		if (ctrl.error.Id_Centro_Usuario || ctrl.error.Estado) return;
		 		var turnos = ''
		 		for (var i = 0; i < ctrl.turnos.length; i++) {
		 			turnos = turnos.length > 0 ? turnos + ',' + ctrl.turnos[i].Id_Turno.toString() : ctrl.turnos[i].Id_Turno.toString();
		 		}
		 		utilsService.swalNotification("Aguarde un instante", "Se está cambiando de estado el turno. </br> Esto puede demorar unos minutos.", "info")
		 		turnosService.Pasar_Estado_Final_Supervision({ 'Id_Turno': turnos, 'Id_Centro_Usuario': item.Id_Centro_Usuario, 'Id_Estado': item.Id_Estado }).$promise.then(function () {
		 			swal({
		 				title: 'Cambiado con éxito',
		 				html: 'Se cambió el estado del turno seleccionado.',
		 				type: 'success',
		 				allowEscapeKey: false,
		 				allowOutsideClick: false
		 			});

		 			ctrl.ctrlPadre.getData(ctrl.ctrlPadre.getDataItem, ctrl.ctrlPadre.query.page, ctrl.ctrlPadre.query.limit, 'grid', ctrl.ctrlPadre.cargarDatos)
		 			ctrl.cerrarModal();
		 		}).catch(function (error) {
		 			utilsService.errores(error);
		 		})

		 	}

		 	ctrl.cerrarModal = function () {
		 		$mdDialog.destroy();
		 	}
		 	//combos de Estado Final
		 	ctrl.searchTerm = {
		 		text: ''
		 	};
		 	ctrl.clearSearchTerm = function () {
		 		ctrl.searchTerm = {
		 			text: ''
		 		};
		 	};
		 }
	],
	template: require('./cambioEstadoFinal.html')
});


// WEBPACK FOOTER //
// ./app/components/supervision/cambioEstadoFinalComponent.js